import snakecaseKeys from 'snakecase-keys';
import { toChainFormat } from '@injectivelabs/utils';
import { InjectiveExchangeV2Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
import { numberToCosmosSdkDecString } from '../../../../utils/numbers.js';
const createMessage = (params) => {
    const message = InjectiveExchangeV2Tx.MsgUpdateSpotMarket.create();
    message.admin = params.admin;
    message.marketId = params.marketId;
    message.newTicker = params.newTicker || '';
    message.newMinNotional = params.newMinNotional || '0';
    message.newMinPriceTickSize = params.newMinPriceTickSize || '0';
    message.newMinQuantityTickSize = params.newMinQuantityTickSize || '0';
    return InjectiveExchangeV2Tx.MsgUpdateSpotMarket.fromPartial(message);
};
/**
 * @category Messages
 */
export default class MsgUpdateSpotMarketV2 extends MsgBase {
    static fromJSON(params) {
        return new MsgUpdateSpotMarketV2(params);
    }
    toProto() {
        const { params: initialParams } = this;
        const params = {
            ...initialParams,
            newMinNotional: toChainFormat(initialParams.newMinNotional || '0').toFixed(),
            newMinQuantityTickSize: toChainFormat(initialParams.newMinQuantityTickSize || '0').toFixed(),
            newMinPriceTickSize: toChainFormat(initialParams.newMinPriceTickSize || '0').toFixed(),
        };
        return createMessage(params);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.exchange.v2.MsgUpdateSpotMarket',
            ...proto,
        };
    }
    toAmino() {
        const { params } = this;
        const msg = createMessage(params);
        const message = {
            ...snakecaseKeys(msg),
        };
        return {
            type: 'exchange/MsgUpdateSpotMarket',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.exchange.v2.MsgUpdateSpotMarket',
            ...value,
        };
    }
    toEip712() {
        const amino = this.toAmino();
        const { type, value } = amino;
        const messageAdjusted = {
            ...value,
        };
        return {
            type,
            value: messageAdjusted,
        };
    }
    toEip712V2() {
        const { params } = this;
        const web3gw = this.toWeb3Gw();
        const messageAdjusted = {
            ...web3gw,
            new_min_price_tick_size: numberToCosmosSdkDecString(params.newMinPriceTickSize || '0'),
            new_min_quantity_tick_size: numberToCosmosSdkDecString(params.newMinQuantityTickSize || '0'),
            new_min_notional: numberToCosmosSdkDecString(params.newMinNotional || '0'),
        };
        return messageAdjusted;
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.exchange.v2.MsgUpdateSpotMarket',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveExchangeV2Tx.MsgUpdateSpotMarket.encode(this.toProto()).finish();
    }
}
